module.exports = __webpack_public_path__ + "static/media/my-courses.aecbe424.svg";